// extracted by mini-css-extract-plugin
export default {"section":"Gallery_section__Gjt+G","images_holer":"Gallery_images_holer__riopN"};